import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, Grid, ModalCloseButton, ModalHeader } from '@chakra-ui/react';
import { ChevronLeft, Dismiss, Icon } from '@whitbread-eos/atoms';
import { modalIconStyle } from '../NavigationMenuMobile.style';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function HeaderSideNav(_ref) {
  var title = _ref.title,
    onClickTitle = _ref.onClickTitle,
    dataTestId = _ref.dataTestId;
  return _jsx(ModalHeader, _objectSpread(_objectSpread({}, modalHeaderStyle), {}, {
    children: _jsxs(Grid, {
      templateColumns: "1fr auto",
      alignItems: "center",
      children: [_jsx(Box, {
        h: "var(--chakra-space-lg)",
        children: title && _jsxs(Flex, {
          alignItems: "center",
          _hover: {
            cursor: 'pointer'
          },
          onClick: onClickTitle,
          "data-testid": "Global-SideNav-BackButton-Mobile",
          children: [_jsx(Icon, {
            svg: _jsx(ChevronLeft, {})
          }), _jsx(Box, {
            py: "0",
            px: "md",
            "data-testid": dataTestId,
            children: title
          })]
        })
      }), _jsx(ModalCloseButton, _objectSpread(_objectSpread({}, modalIconStyle), {}, {
        children: _jsx(Icon, {
          svg: _jsx(Dismiss, {
            "data-testid": "closeModal"
          })
        })
      }))]
    })
  }));
}
var modalHeaderStyle = {
  h: 'var(--chakra-space-14)',
  p: 'md',
  fontWeight: 'medium',
  lineHeight: '3',
  fontSize: 'md',
  alignItems: 'center',
  color: 'primary',
  borderBottom: 'var(--chakra-space-px) solid var(--chakra-colors-lightGrey2)'
};